import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("UnsupportedTerminal", "ExpressionTerminal", {
    type: function() {
      return 'Unsupported';
    }
  });
});
